import { Box, Typography } from '@mui/material';
import React from 'react';

import LinkList, { ListItemOrientation, ListItemType } from './LinkList';
import { getChannelLink } from '../../utils/link.utils';
import { IdAndName } from '../../shared/types';

interface ChannelLinkListProps {
    title: string;
    channels?: IdAndName[];
}

export const ChannelLinkList: React.FC<ChannelLinkListProps> = ({
    title,
    channels,
}) => {
    if (!channels?.length) return null;

    const linksList = channels?.map(({ _id, name }) => ({
        id: _id,
        name: name,
        url: getChannelLink(_id),
    }));

    return (
        <Box>
            <Typography sx={{ mb: 2 }} variant="body2">
                {title}
            </Typography>
            <Box id={'channel-link-list'}>
                <LinkList
                    disableSort
                    items={linksList}
                    orientation={ListItemOrientation.Vertical}
                    displayType={ListItemType.Link}
                    isSpacedVerticalLinks={true}
                />
            </Box>
        </Box>
    );
};
